export default {"src":"/_next/static/media/date.e9017b6b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};